import {alias, createModelSchema, list} from "serializr";
import {BaseObject} from "@/common/BaseObject";

import {RewardPackageConfig} from "./RewardPackageConfig";
import {Schema} from "@/common/Schema";

export class RewardPackage extends BaseObject {

  constructor() {
    super();
    this._key = null;
    this._name = null;
    this._desc = null;
    this._guardedMainMap = null;
    this._configs = [];
  }

  get key() {
    return this._key;
  }

  set key(value) {
    this._key = value;
  }

  get name() {
    return this._name;
  }

  set name(value) {
    this._name = value;
  }

  get desc() {
    return this._desc;
  }

  set desc(value) {
    this._desc = value;
  }

  get guardedMainMap() {
    return this._guardedMainMap;
  }

  set guardedMainMap(value) {
    this._guardedMainMap = value;
  }

  get configs() {
    return this._configs;
  }

  set configs(value) {
    this._configs = value;
  }

  valid() {
    if (!this.configs || this.configs.length === 0) {
      return false;
    }

    if (this.configs.some(v => !v || v.empty() || !v.valid())) {
      return false;
    }

    return true;
  }

  empty() {
    return this.configs.length === 0;
  }

  copy() {
    return super.copy();
  }

  clone(target = undefined) {
    if (!target) {
      return super.clone(new RewardPackage());
    } else if (target instanceof RewardPackage) {
      return super.clone(target);
    } else {
      console.assert(false);
      return undefined;
    }
  }
}

createModelSchema(RewardPackage, {
  _key: alias("key", Schema.primitive()),
  _name: alias("name", Schema.primitive()),
  _desc: alias("desc", Schema.primitive()),
  _guardedMainMap: alias("guarded_main_map", Schema.primitive()),
  _configs: alias("configs", list(RewardPackageConfig.schema()))
});